import type { ReactNode } from "react"
import ReactDOM from "react-dom"

export interface HeadProps {
  children: ReactNode
}

/**
 * Use ReactPortals to place object in the document head
 */
export function Head(props: HeadProps) {
  return ReactDOM.createPortal(props.children, document.head)
}
